import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ConfirmationPopupProps from "./confirmation-popup.props";
import DeleteIcon from "../../../assets/icons/delete.svg";
import CloseIcon from "../../../assets/icons/closeIcon.svg";
import "./popup.scss";

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  title,
  open,
  onCancel,
  onOkay,
  note,
  buttonText,
  showIcon = true,
  Icon,
  className,
  isDoNotSendButtonRequired = false,
  extraButtonText,
  onExtraButtonOkay,
  cancelButtonText="Cancel"
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose=
        {(event, reason) => {
          if (reason !== "backdropClick") {
            onCancel();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`confirmation-popup-wrapper ${className || ""}`}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="header-wrapper">
            {showIcon ? (
              <div className="image-wrapper">
                <div className="title-with-icon">
                  <img src={Icon || DeleteIcon} className="delete-icon"></img>
                  <div>{title}</div>
                </div>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={onCancel}
                />
              </div>
            ) :  <div>{title}</div>}
      
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {note}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} className="cancel-btn">
            {cancelButtonText}
          </Button>
          {isDoNotSendButtonRequired && (
            <Button onClick={onExtraButtonOkay} className="cancel-btn">
              {extraButtonText}
            </Button>
          )}
          <Button onClick={onOkay} autoFocus className="action-btn">
            {buttonText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationPopup;
